import { SwitchField } from '@mi-front/ui';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { ReportsListFilter } from './types';

export function ReportListFilterForm() {
  const { formatMessage } = useIntl();
  const fp = useFormikContext<ReportsListFilter>();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        fp.submitForm();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="row">
      <div className="col-4">
        <SwitchField
          label={formatMessage({
            id: 'audit.reportsList.showOther',
            defaultMessage: 'Mostrar reportes de otros usuarios',
          })}
          size="sm"
          name="showOther"
        />
      </div>
    </div>
  );
}
